import {
  getGlobalStatistics
} from "./chunk.DJW5UPIU.js";

// src/lib/core/types/enums.ts
var FreeTextFieldMode = /* @__PURE__ */ ((FreeTextFieldMode2) => {
  FreeTextFieldMode2["EQUALS_TO"] = "EQUALS_TO";
  FreeTextFieldMode2["DIFFERENT_FROM"] = "DIFFERENT_FROM";
  FreeTextFieldMode2["FREE_RESPONSE"] = "FREE_RESPONSE";
  FreeTextFieldMode2["REGEX"] = "REGEX";
  return FreeTextFieldMode2;
})(FreeTextFieldMode || {});
var DeliverabilityChartBarStatus = /* @__PURE__ */ ((DeliverabilityChartBarStatus2) => {
  DeliverabilityChartBarStatus2["READ"] = "READ";
  DeliverabilityChartBarStatus2["RECEIVED"] = "RECEIVED";
  DeliverabilityChartBarStatus2["SENT"] = "SENT";
  DeliverabilityChartBarStatus2["MNC"] = "MNC";
  DeliverabilityChartBarStatus2["ERROR"] = "ERROR";
  DeliverabilityChartBarStatus2["OTHER"] = "OTHER";
  return DeliverabilityChartBarStatus2;
})(DeliverabilityChartBarStatus || {});
var DeliverabilityChartBarStatusTranslation = /* @__PURE__ */ ((DeliverabilityChartBarStatusTranslation2) => {
  DeliverabilityChartBarStatusTranslation2["READ"] = "Lu";
  DeliverabilityChartBarStatusTranslation2["RECEIVED"] = "Re\xE7u";
  DeliverabilityChartBarStatusTranslation2["SENT"] = "Envoy\xE9";
  DeliverabilityChartBarStatusTranslation2["MNC"] = "Mobile non compatible";
  DeliverabilityChartBarStatusTranslation2["ERROR"] = "Erreur";
  DeliverabilityChartBarStatusTranslation2["OTHER"] = "Autre";
  return DeliverabilityChartBarStatusTranslation2;
})(DeliverabilityChartBarStatusTranslation || {});
var DeliverabilityStatusesTranslation = /* @__PURE__ */ ((DeliverabilityStatusesTranslation2) => {
  DeliverabilityStatusesTranslation2["START_COMMUNICATION"] = "D\xE9part";
  DeliverabilityStatusesTranslation2["IS_TYPING"] = "Est en train de taper";
  DeliverabilityStatusesTranslation2["MESSAGE_OPENED"] = "Message ouvert";
  DeliverabilityStatusesTranslation2["RECEIVED"] = "Re\xE7u";
  DeliverabilityStatusesTranslation2["DELAY_EXPIRED"] = "Expir\xE9";
  DeliverabilityStatusesTranslation2["RESPONSE_RECEIVED"] = "R\xE9ponse re\xE7ue";
  DeliverabilityStatusesTranslation2["PROCESSING"] = "En cours";
  DeliverabilityStatusesTranslation2["MESSAGE_SENT_TO_USER"] = "Envoy\xE9";
  DeliverabilityStatusesTranslation2["REFUSED_BY_OPERATOR"] = `Refus\xE9 par l'op\xE9rateur`;
  DeliverabilityStatusesTranslation2["UNREACHABLE"] = "Injoignable";
  DeliverabilityStatusesTranslation2["FAILURE"] = "\xC9chec";
  DeliverabilityStatusesTranslation2["OPT_OUT"] = "D\xE9sinscrit";
  DeliverabilityStatusesTranslation2["END_OF_CONVERSATION"] = "Fin de conversation";
  DeliverabilityStatusesTranslation2["UNKNOWN"] = "Inconnu";
  return DeliverabilityStatusesTranslation2;
})(DeliverabilityStatusesTranslation || {});
var CardHeightEnum = /* @__PURE__ */ ((CardHeightEnum2) => {
  CardHeightEnum2["TALL"] = "TALL";
  CardHeightEnum2["MEDIUM"] = "MEDIUM";
  CardHeightEnum2["SHORT"] = "SHORT";
  return CardHeightEnum2;
})(CardHeightEnum || {});
var CardOrientationEnum = /* @__PURE__ */ ((CardOrientationEnum2) => {
  CardOrientationEnum2["VERTICAL"] = "VERTICAL";
  CardOrientationEnum2["HORIZONTAL"] = "HORIZONTAL";
  return CardOrientationEnum2;
})(CardOrientationEnum || {});
var CardImageAlignmentEnum = /* @__PURE__ */ ((CardImageAlignmentEnum2) => {
  CardImageAlignmentEnum2["LEFT"] = "LEFT";
  CardImageAlignmentEnum2["RIGHT"] = "RIGHT";
  return CardImageAlignmentEnum2;
})(CardImageAlignmentEnum || {});

// src/lib/hooks/stats/use-get-stats-dashboard.ts
import { useSuspenseQuery } from "@tanstack/react-query";
function useGetGlobalStatistics({
  entityId,
  campaignId
}) {
  return useSuspenseQuery({
    queryKey: ["rcsGlobalDashboard", entityId, campaignId],
    queryFn: () => getGlobalStatistics({ entityId, campaignId })
  }).data ?? {};
}

export {
  FreeTextFieldMode,
  DeliverabilityChartBarStatus,
  DeliverabilityChartBarStatusTranslation,
  DeliverabilityStatusesTranslation,
  CardHeightEnum,
  CardOrientationEnum,
  CardImageAlignmentEnum,
  useGetGlobalStatistics
};
